import React, { ReactNode } from 'react';
import styled from 'styled-components';
import useDashboardSelector from '../../../redux/selectorHooks/useDashboardSelector';
import {
  FloatingToolbar,
  NewConversationOverlay,
} from '../../../components/Conversations';
import { assertNotNil } from '../../../utils/types';
import { ConversationThreadEntityType } from '../../../utils/apollo/graphqlSchema';
import { DASHBOARD_COMMENT_OVERLAY_Z_INDEX } from '../utils/constants';
import { useAppSelector } from '../../../redux/hooks';
import useTrackDashboardCommentCreate from '../utils/useTrackDashboardCommentCreate';
import { IS_SCREENSHOT_MODE } from '../../../config/constants';

interface IProps {
  children: ReactNode;
}

const Container = styled.div`
  position: relative;
`;

const DashboardInstanceWrapper = ({ children }: IProps) => {
  const dashboard = useDashboardSelector('dashboard');
  assertNotNil(dashboard);
  const isCommentMode = useAppSelector(
    (state) => state.conversationThreads.isCommentMode,
  );
  const trackNewComment = useTrackDashboardCommentCreate('dashboard');

  if (IS_SCREENSHOT_MODE) {
    return <Container>{children}</Container>;
  }

  return (
    <Container>
      {isCommentMode && (
        <NewConversationOverlay
          entityId={dashboard.baseId}
          entityType={ConversationThreadEntityType.Dashboard}
          zIndex={DASHBOARD_COMMENT_OVERLAY_Z_INDEX}
          onSubmit={trackNewComment}
        />
      )}
      {children}
      <FloatingToolbar />
    </Container>
  );
};

export default DashboardInstanceWrapper;
